module.exports = __webpack_public_path__ + "static/media/b1.da3162d0.jpg";